/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import CurvedText from '../../../../../components/Controller/ActionPanel/CurvedText';
import { IS_TAB } from '../../../../../utils/common';
import Carousel from '../../../../../components/common/Carousel';
import useCarouselItemConfig from '../../../../../hooks/useCarouselItemConfig';

const Placement = ({
  options,
  tShirtBikeBackText,
  updatePartsConfig,
  allBikeArtData
}) => {
  const { ref: cardRef, width: cardWidth } = useCarouselItemConfig();
  return (
    <div className="placement">
      {IS_TAB ? (
        <Carousel noOfItems={3} itemWidth={cardWidth}>
          {options.map(option => {
            let position;
            if (option.name === 'BACK_TEXT_CURVE')
              position = `placement_item placement_item-curve`;
            else if (option.name === 'BACK_TEXT_BOTTOM')
              position = `placement_item placement_item-bottom`;
            else if (option.name === 'BACK_TEXT_TOP')
              position = `placement_item placement_item-top`;
            else return;
            return (
              <div
                ref={cardRef}
                className={position}
                onClick={() => {
                  updatePartsConfig(
                    option,
                    'bikeArt',
                    allBikeArtData
                      .filter(
                        cust =>
                          cust.customizationType !== 'placement' ||
                          !cust.customizationType
                      )
                      .map(entry => entry.partId)
                  );
                }}
              >
                <h4 className="placement_item_text">
                  {!option.configData.label.includes('curve') &&
                    (tShirtBikeBackText[0].line || 'Your Text')}
                  {option.configData.label.includes('curve') && (
                    <CurvedText
                      text={tShirtBikeBackText[0].line || 'Your Text'}
                      radius={75}
                    />
                  )}
                </h4>
              </div>
            );
          })}

          {/* <div
            className="placement_item placement_item-top"
            onClick={() => {
              updatePartsConfig(
                options[0],
                'bikeArt',
                allBikeArtData
                  .filter(
                    cust =>
                      cust.customizationType !== 'placement' ||
                      !cust.customizationType
                  )
                  .map(entry => entry.partId)
              );
            }}
          >
            <h4 className="placement_item_text">
              {tShirtBikeBackText[0].line || 'Your Text'}
            </h4>
          </div>
          <div
            className="placement_item placement_item-curve"
            onClick={() => {
              updatePartsConfig(
                options[2],
                'bikeArt',
                allBikeArtData
                  .filter(
                    cust =>
                      cust.customizationType !== 'placement' ||
                      !cust.customizationType
                  )
                  .map(entry => entry.partId)
              );
            }}
          >
            <h4 className="placement_item_text">
              <CurvedText
                text={tShirtBikeBackText[0].line || 'Your Text'}
                radius={75}
              />
            </h4>
          </div> */}
        </Carousel>
      ) : (
        <div className="placement_wrap">
          {options.map(option => {
            let position;
            if (option.name === 'BACK_TEXT_CURVE')
              position = `placement_item placement_item-curve`;
            else if (option.name === 'BACK_TEXT_BOTTOM')
              position = `placement_item placement_item-bottom`;
            else if (option.name === 'BACK_TEXT_TOP')
              position = `placement_item placement_item-top`;
            else return;
            return (
              <div
                ref={cardRef}
                className={position}
                onClick={() => {
                  updatePartsConfig(
                    option,
                    'bikeArt',
                    allBikeArtData
                      .filter(
                        cust =>
                          cust.customizationType !== 'placement' ||
                          !cust.customizationType
                      )
                      .map(entry => entry.partId)
                  );
                }}
              >
                <h4 className="placement_item_text">
                  {!option.configData.label.includes('curve') &&
                    (tShirtBikeBackText[0].line || 'Your Text')}
                  {option.configData.label.includes('curve') && (
                    <CurvedText
                      text={tShirtBikeBackText[0].line || 'Your Text'}
                      radius={75}
                    />
                  )}
                </h4>
              </div>
            );
          })}

          {/* <div
              className="placement_item placement_item-bottom"
              onClick={() => {
                updatePartsConfig(
                  options[1],
                  'bikeArt',
                  allBikeArtData
                    .filter(
                      cust =>
                        cust.customizationType !== 'placement' ||
                        !cust.customizationType
                    )
                    .map(entry => entry.partId)
                );
              }}
            >
              <h4 className="placement_item_text">
                {tShirtBikeBackText[0].line || 'Your Text'}
              </h4>
            </div>
            <div
              className="placement_item placement_item-top"
              onClick={() => {
                updatePartsConfig(
                  options[0],
                  'bikeArt',
                  allBikeArtData
                    .filter(
                      cust =>
                        cust.customizationType !== 'placement' ||
                        !cust.customizationType
                    )
                    .map(entry => entry.partId)
                );
              }}
            >
              <h4 className="placement_item_text">
                {tShirtBikeBackText[0].line || 'Your Text'}
              </h4>
            </div>
            <div
              className="placement_item placement_item-curve"
              onClick={() => {
                updatePartsConfig(
                  options[2],
                  'bikeArt',
                  allBikeArtData
                    .filter(
                      cust =>
                        cust.customizationType !== 'placement' ||
                        !cust.customizationType
                    )
                    .map(entry => entry.partId)
                );
              }}
            >
              <h4 className="placement_item_text">
                <CurvedText
                  text={tShirtBikeBackText[0].line || 'Your Text'}
                  radius={75}
                />
              </h4>
            </div> */}
        </div>
      )}
    </div>
  );
};

Placement.propTypes = {
  currentText: PropTypes.string
};

export default Placement;
